export const visitorId = () => {
  let id = localStorage.getItem("hc_visitor");
  if (!id) { id = crypto.randomUUID(); localStorage.setItem("hc_visitor", id); }
  return id;
};

export const streamPost = async (url, body, onEvent) => {
  const res = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(typeof j.detail === "string" ? j.detail : "Request failed.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const ev = JSON.parse(p.replace(/^data: /, ""));
      if (ev.error) throw new Error(ev.error);
      onEvent(ev);
    }
  }
};
